<div class="px-3">
  <h2>{{ 'securityAudit.title' | translate }}</h2>
  <gstar-prime-grid
    #grid
    [source]="securitiesAudit().items"
    [totalRows]="securitiesAudit().total"
    [isLoading]="isLoading()"
    [headers]="headers()"
    [settings]="setting"
    (queryChange)="queryHandler($event)" />
</div>
